import { render, staticRenderFns } from "./QuizzzNite.vue?vue&type=template&id=8c5544d0&scoped=true"
import script from "./QuizzzNite.vue?vue&type=script&lang=ts"
export * from "./QuizzzNite.vue?vue&type=script&lang=ts"
import style0 from "./QuizzzNite.vue?vue&type=style&index=0&id=8c5544d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5544d0",
  null
  
)

export default component.exports